import { BillingReminder, DisputedReasons } from "@/app/features/InvoiceBillingReminder/billingReminder.types"
import { Modal, RadioGroup, TextArea } from "@triumph/design-system"
import { useTranslation } from "react-i18next"
import { getDisputedReasons } from "../../api/endpoints/disputedReasons"
import { useEffect, useState } from "react"
import { radio } from "@triumph/design-system/components/RadioGroup/RadioGroup.types"
import { InvoicesDashboard } from "@/app/features/DebtorPortal/Dashboard/dashboard.types"

interface TextboxModalProps {
    isVisible: (boolean),
    showDisputedReasons: (boolean),
    rows: (BillingReminder[] | InvoicesDashboard[]),
    inputValue: (string),
    textValue: (string),
    reasonValue: (string),
    handleClose: () => void,
    handleSubmit: (invoiceNumber: string, value: string, disputedReasonId?: string, disputedReasonDesc?: string) => void,
    setTextValue: (textValue: string) => void,
    setReasonValue: (textValue: string) => void
}

export const TextboxModal = ({
    isVisible,
    showDisputedReasons,
    rows,
    inputValue,
    textValue,
    reasonValue,
    handleClose,
    handleSubmit,
    setTextValue,
    setReasonValue
}: TextboxModalProps) => {
    const [disputedReasons, setDipsutedReasons] = useState<radio[]>([]);
    const [disputedReasonsRaw, setDisputedReasonsRaw] = useState<DisputedReasons[]>([]);
    const [selectedDisputedReason, changeSelectedDisputedReason] = useState<string>("");
    const getOptions= async () => {
        const options: DisputedReasons[] =  await getDisputedReasons();
        const mappedOptions: radio[] = options.map((item) => ({
            value: item.statusReasonCodeName.toString(),
            id: item.id.toString(),
        }));
        setDipsutedReasons(mappedOptions);
        setDisputedReasonsRaw(options);
    }

    const activeReasonId = reasonValue || selectedDisputedReason;
    const activeReasonRaw = disputedReasonsRaw.find((r) => r.id.toString() === activeReasonId);
    const isNoteRequired = activeReasonRaw?.noteRequired ?? false;

    const setNote = (text: string) => {
        setTextValue(text);
    }

    const setSelectedReasonValue = (reasonId: string) => {
        changeSelectedDisputedReason(reasonId);
        setReasonValue(reasonId);
    }

    const submitClicked = () => {
        changeSelectedDisputedReason("");
        handleSubmit(inputValue, textValue, reasonValue, disputedReasons.find(reason=> reason.id === reasonValue)?.value);
    }

    const closeClicked = () => {
        changeSelectedDisputedReason("");
        handleClose();
    }

    const getCarrierName = (row: BillingReminder | InvoicesDashboard): string => {
    if ('clientName' in row && row.clientName) {
        return row.clientName;
    }
    if ('carrierName' in row && row.carrierName) {
        return row.carrierName;
    }
    return '';
};

    useEffect(() => {
        getOptions();
    },[]);

    const { t } = useTranslation('billingReminder');
    const currentRow = rows.find((row) =>
                row.invoiceNumber === inputValue);
    const carrierName = currentRow ? getCarrierName(currentRow) : '';

    return (
        <Modal 
            id={inputValue}
            onClose={() => {closeClicked()}} 
            visible={isVisible} 
            headerContent= {null}
            onPrimaryAction={() => submitClicked()}
            onSecondaryAction={() => {closeClicked()}}
            primaryButtonText={t('button.submit')}
            secondaryButtonText={t('button.cancel')}
            primaryAdditionalProps={{disabled : isNoteRequired && textValue === ""}}
            bodyContent={
                <div>INVOICE: {currentRow?.invoiceNumber}<br/>Carrier: {carrierName}<br/>Amount: {currentRow?.amount}
                {showDisputedReasons ? 
                    <RadioGroup label="" radios={disputedReasons} onChange={(event:any)=> setSelectedReasonValue(event.target.id)} required={false} id={""}  selected={reasonValue != "" ?reasonValue: selectedDisputedReason}/> 
                    : null}
                <TextArea 
                    id={`modal-text-area-${inputValue}`} 
                    labelText={showDisputedReasons ? (isNoteRequired ? t("modal.modalNoteRequired") : t("modal.modalReasonLabel")) : t("modal.modalLabel")}
                    onChange={(text) => setNote(text.target.value)}
                    value={textValue}
                    characterLimit={150}
                    disabled={false}
                />
                </div>
            }>
        </Modal>
    )
}
